import { css } from 'styled-components';

export const hCenterRow = css`
  display: flex;
  justify-content: center;
`;
